import { UserRole } from "tm-shared/types";

import { isManagerRole } from "@/utils";

export interface MainInformationCapabilities {
    canClearActiveSchedule: boolean;
}

export const getMainInformationCapabilities = (
    role: UserRole,
): MainInformationCapabilities => {
    return {
        canClearActiveSchedule: isManagerRole(role),
    };
};
